import { css } from '@lyearn/style';

export const setWidth = (width: number) => css`
  width: ${width / 10}rem;
`;

export const setMaxHeight = (maxHeight: string | number) => css`
  max-height: ${typeof maxHeight === 'number' ? `${maxHeight / 10}rem` : maxHeight};
`;
